import { Badge, Box, Button, CircularProgress, Tooltip } from '@material-ui/core'
import LocalOfferIcon from '@material-ui/icons/LocalOffer'
import React from 'react'
import Add from '@material-ui/icons/Add'
import { Indicator } from '../../../../types'

export function SetTagButton(props: { indicator: Indicator<boolean>; callback: Function; branch: string; index: number }) {
  const { indicator, callback, branch, index } = props

  function callbackIndex() {
    callback(index)
  }

  if (indicator.fetching) {
    return (
      <Box className='tableCenterSpinner'>
        <CircularProgress size={25} />
      </Box>
    )
  } else {
    if (!indicator.value) {
      const tip = 'Tag latest commit on ' + branch
      return (
        <Tooltip title={tip}>
          <Button className='no-padding' onClick={callbackIndex}>
            <Badge anchorOrigin={{ vertical: 'top', horizontal: 'right' }} badgeContent={<Add className='badgeIcon' />} color='primary' overlap='rectangle'>
              <LocalOfferIcon />
            </Badge>
          </Button>
        </Tooltip>
      )
    }
  }
  return null
}
